module.exports = __webpack_public_path__ + "img/CityJungle_Team_033-min.4811d806.jpg";